import SettingContainer from 'components/feature/workspace/SettingContainer';

const SettingPage = () => {
  return <SettingContainer />;
};

export default SettingPage;
